module.exports = __webpack_public_path__ + "media/reskin-images/icon--more-horizontal-6f5698ad.svg";